export async function fetchWithRetry<T, U extends any[]>(
  fetchFunction: (...args: U) => Promise<T>,
  fetchFunctionArgs: U,
  successCondition: (response: T) => boolean,
  time: {
    timeoutMs: number;
    intervalMs: number;
  },
): Promise<T> {
  const { intervalMs, timeoutMs } = time;
  const startTime = Date.now();
  const endTime = startTime + timeoutMs;
  let lastValidResponse: T | null = null;

  while (Date.now() < endTime) {
    try {
      const response = await fetchFunction(...fetchFunctionArgs);
      lastValidResponse = response;

      if (successCondition(response)) {
        return response;
      }

      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
  }

  if (lastValidResponse !== null) {
    return lastValidResponse;
  }

  throw new Error('Timeout: the correct answer was not obtained.');
}
